export default __webpack_public_path__ + "static/media/hht2_ep08_timeline_08_blank.80adfa9b.png";